var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.isLoggedIn == false)?[_c('router-view')]:[_c('header-view'),_c('main',[_c('div',{staticClass:"container main-container"},[_c('router-view')],1)])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }